import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import auth from "./modules/auth";
import balance from "./modules/balance";

Vue.use(Vuex);

export default new Vuex.Store({
  debug: true,
  modules: {
    app,
    auth,
    balance
  }
});
